export default __webpack_public_path__ + "static/media/mettl.5585d4c0.svg";